module.exports = __webpack_public_path__ + "img/purchase.130d5f2a.png";